export const FABRIC_TEXTURES = {
  "fabricTextures": [
    {
      "category": "Smooth & Lustrous",
      "types": [
        { "name": "Satin", "description": "Glossy, smooth surface with a luxurious sheen." },
        { "name": "Silk", "description": "Natural, soft, smooth, and slightly lustrous." },
        { "name": "Poplin", "description": "Smooth and crisp, tightly woven cotton or polyester." },
        { "name": "Sateen", "description": "Cotton fabric with a satin-like sheen." },
        { "name": "Chiffon", "description": "Lightweight, sheer, and smooth fabric with soft drape." },
        { "name": "Georgette", "description": "Light, sheer fabric with a slightly grainy texture." },
        { "name": "Crepe", "description": "Wrinkled or crinkled texture, can be soft or crisp." },
        { "name": "Tencel/Lyocell", "description": "Smooth, eco-friendly fabric with a silky feel." },
        { "name": "Charmeuse", "description": "Light, drapey satin weave with high lustre." },
        { "name": "Habotai", "description": "Lightweight, smooth silk with soft sheen." }
      ]
    },
    {
      "category": "Soft, Plush & Fuzzy",
      "types": [
        { "name": "Velvet", "description": "Soft, dense pile with a rich feel and sheen." },
        { "name": "Velour", "description": "Stretchy velvet-like fabric, softer and lighter." },
        { "name": "Fleece", "description": "Warm, fluffy surface, often used in winter wear." },
        { "name": "Polar Fleece", "description": "Thicker, insulating fleece with soft hand." },
        { "name": "Chenille", "description": "Soft, fuzzy surface with caterpillar-like yarns." },
        { "name": "Minky", "description": "Ultra-soft microfiber plush used for blankets and babywear." },
        { "name": "Plush", "description": "Deep, soft pile with a velvety hand." },
        { "name": "Sherpa", "description": "Thick, wool-like pile with fluffy warmth." },
        { "name": "Cashmere", "description": "Luxuriously soft, fine wool with a smooth hand." },
        { "name": "Suede", "description": "Brushed leather with a soft, napped surface." },
        { "name": "Microsuede", "description": "Synthetic suede with a fine, smooth nap." }
      ]
    },
    {
      "category": "Rough & Textured",
      "types": [
        { "name": "Tweed", "description": "Rough, woolen, irregular texture with specks of color." },
        { "name": "Bouclé", "description": "Looped, curly yarn texture with a bumpy feel." },
        { "name": "Corduroy", "description": "Ribbed texture with raised vertical ridges (wales)." },
        { "name": "Herringbone", "description": "Distinct V-shaped woven pattern." },
        { "name": "Houndstooth", "description": "Broken check weave with jagged edges." },
        { "name": "Matelassé", "description": "Raised quilt-like texture woven into fabric." },
        { "name": "Seersucker", "description": "Puckered, wrinkly texture, often striped." },
        { "name": "Barkcloth", "description": "Thick, rough cotton with bark-like surface." },
        { "name": "Slub", "description": "Irregular, nubby texture from thick-and-thin yarns." }
      ]
    },
    {
      "category": "Crisp & Structured",
      "types": [
        { "name": "Linen", "description": "Crisp, slightly rough texture, breathable with slubs." },
        { "name": "Taffeta", "description": "Crisp, smooth, and slightly shiny with a rustling sound." },
        { "name": "Organza", "description": "Stiff, sheer, and crisp, often used in gowns." },
        { "name": "Voile", "description": "Light, crisp cotton with semi-sheer quality." },
        { "name": "Organdy", "description": "Crisp, sheer cotton fabric with stiffness." },
        { "name": "Grosgrain", "description": "Ribbed fabric with a firm hand, often in ribbons." },
        { "name": "Canvas", "description": "Heavy, coarse, and durable cotton weave." },
        { "name": "Duck Cloth", "description": "Durable, tightly woven heavy cotton." },
        { "name": "Faille", "description": "Fine-ribbed fabric with a firm, crisp hand." },
        { "name": "Ottoman", "description": "Pronounced horizontal ribs with a firm structure." }
      ]
    },
    {
      "category": "Knitted & Stretchy",
      "types": [
        { "name": "Jersey", "description": "Soft, stretchy knit with a smooth surface." },
        { "name": "Rib Knit", "description": "Elastic fabric with raised vertical ribs." },
        { "name": "Interlock Knit", "description": "Double-knit with smooth, soft surface." },
        { "name": "Mesh/Net", "description": "Open, porous knit with visible holes." },
        { "name": "Lace", "description": "Delicate, decorative openwork fabric." },
        { "name": "Crochet", "description": "Looped handmade knit texture." },
        { "name": "Spandex/Lycra", "description": "Smooth, elastic synthetic fabric with stretch." },
        { "name": "Waffle/Thermal Knit", "description": "Honeycomb-like cells that trap warmth." },
        { "name": "Pointelle", "description": "Delicate knit with small eyelet holes." },
        { "name": "Cable Knit", "description": "Raised, twisted rope-like knit pattern." }
      ]
    },
    {
      "category": "Natural & Rustic",
      "types": [
        { "name": "Denim", "description": "Twill weave, rugged texture with diagonal ribbing." },
        { "name": "Chambray", "description": "Lightweight denim-like fabric with smooth finish." },
        { "name": "Jute", "description": "Coarse, rustic fiber used in bags and rugs." },
        { "name": "Hemp", "description": "Strong, coarse, eco-friendly natural fiber." },
        { "name": "Burlap", "description": "Rough, loosely woven jute or hemp fabric." },
        { "name": "Khadi", "description": "Handspun cotton with slubbed, uneven texture." },
        { "name": "Calico", "description": "Unbleached cotton with rough feel and print potential." }
      ]
    },
    {
      "category": "Woven Patterned & Structured Weaves",
      "types": [
        { "name": "Jacquard", "description": "Complex woven patterns created on a jacquard loom." },
        { "name": "Brocade", "description": "Rich, raised patterns often with metallic threads." },
        { "name": "Damask", "description": "Reversible woven patterns with matte and sheen contrast." },
        { "name": "Dobby", "description": "Small geometric patterns created by dobby loom." },
        { "name": "Tapestry", "description": "Heavy fabric with pictorial woven designs." },
        { "name": "Basketweave", "description": "Over-under groups of yarns creating a checker texture." },
        { "name": "Oxford", "description": "Basket-like weave with soft hand, common in shirts." },
        { "name": "Twill", "description": "Diagonal ribs from offset interlacing. Visible pattern is often tonal, formed by weave-direction changes in one overall color — not a printed or yarn-dyed colored check." },
        { "name": "Hopsack", "description": "Looser basket weave with textured hand." }
      ]
    },
    {
      "category": "Sheer & Delicate",
      "types": [
        { "name": "Tulle", "description": "Light, netted fabric often used in gowns and veils." },
        { "name": "Organza", "description": "Stiff, sheer, crisp fabric for structured garments." },
        { "name": "Voile", "description": "Lightweight, sheer cotton fabric with smooth finish." },
        { "name": "Gauze", "description": "Light, airy cotton with open weave." },
        { "name": "Muslin", "description": "Soft, plain-woven cotton, semi-sheer." },
        { "name": "Batiste", "description": "Fine, lightweight semi-sheer plain weave." },
        { "name": "Ninon", "description": "Very light, sheer fabric with open weave." }
      ]
    },
    {
      "category": "Quilted & Padded",
      "types": [
        { "name": "Quilted Cotton", "description": "Layered cotton stitched with padding for warmth." },
        { "name": "Matelassé", "description": "Woven to look padded with raised texture." },
        { "name": "Polyester Padding", "description": "Soft, synthetic wadding for insulated garments." },
        { "name": "Piqué", "description": "Textured raised weave, commonly used in polo shirts." },
        { "name": "Down/Feather Channels", "description": "Baffled channels filled for insulation." }
      ]
    },
    {
      "category": "Technical & Performance",
      "types": [
        { "name": "Neoprene", "description": "Spongy, synthetic rubber fabric used in wetsuits." },
        { "name": "Gore-Tex", "description": "Waterproof, breathable laminated fabric." },
        { "name": "Nylon Ripstop", "description": "Cross-hatch woven fabric, resistant to tearing." },
        { "name": "Polyester Microfiber", "description": "Ultra-fine synthetic fabric, smooth and soft." },
        { "name": "Spacer Fabric", "description": "3D knit structure, breathable, used in sneakers." },
        { "name": "Softshell", "description": "Bonded stretch woven + fleece back for weather resistance." },
        { "name": "Cordura", "description": "High-tenacity nylon with rugged texture." },
        { "name": "Kevlar/Aramid", "description": "High-strength heat-resistant fibers; coarse hand." },
        { "name": "Coolmax", "description": "Moisture-wicking polyester with smooth hand." }
      ]
    },
    {
      "category": "Embellished & Decorative",
      "types": [
        { "name": "Sequin (Sequined)", "description": "Surface covered with small reflective discs; smooth but bumpy to touch." },
        { "name": "Paillette", "description": "Large sequins creating bold shimmer and texture." },
        { "name": "Beaded", "description": "Beads stitched on surface for raised decorative texture." },
        { "name": "Embroidery", "description": "Raised stitched designs adding tactile patterns." },
        { "name": "Appliqué", "description": "Pieces of fabric sewn onto base creating layered relief." },
        { "name": "Eyelet (Broderie Anglaise)", "description": "Small cut-out holes finished with embroidery." },
        { "name": "Flocked", "description": "Short fiber dust adhered to create velvet-like motifs." },
        { "name": "Foil Print", "description": "Metallic foil applied to surface with slight stiffness." },
        { "name": "Dévoré (Burnout)", "description": "Chemical process creates sheer motifs in pile fabrics." }
      ]
    },
    {
      "category": "Crinkled & Pleated",
      "types": [
        { "name": "Plissé", "description": "Chemically set crinkles forming rippled texture." },
        { "name": "Crinkle", "description": "Irregular, permanent wrinkled surface." },
        { "name": "Crushed", "description": "Deliberately crushed texture (e.g., crushed velvet)." },
        { "name": "Pleated (Accordion/Knife)", "description": "Regular folds permanently set for texture and structure." }
      ]
    },
    {
      "category": "Coated, Metallic & Laminated",
      "types": [
        { "name": "Lamé", "description": "Fabric woven or coated with metallic yarns; shiny and smooth." },
        { "name": "Lurex Knit/Woven", "description": "Metallic yarn blended into base fabric for sparkle." },
        { "name": "PU-Coated", "description": "Polyurethane film coating; smooth, sometimes rubbery." },
        { "name": "PVC-Coated", "description": "Vinyl-coated surface with slick hand." },
        { "name": "Waxed Cotton / Oilcloth", "description": "Wax finish; stiff, water-resistant, slightly tacky hand." },
        { "name": "Patent Leather", "description": "High-gloss coated leather with mirror finish." }
      ]
    },
    {
      "category": "Fur & Hairy",
      "types": [
        { "name": "Faux Fur", "description": "Synthetic pile mimicking animal fur; long or short nap." },
        { "name": "Shearling", "description": "Sheepskin with clipped fleece; suede one side, wool the other." },
        { "name": "Mohair", "description": "Angora goat fiber; silky, slightly fuzzy halo." },
        { "name": "Alpaca", "description": "Soft, warm fiber with gentle fuzz." },
        { "name": "Angora", "description": "Rabbit fiber; ultra-soft with pronounced halo." }
      ]
    },
    {
      "category": "Nonwoven & Felted",
      "types": [
        { "name": "Felt (Wool Felt)", "description": "Matted fibers pressed together; dense, smooth surface." },
        { "name": "Bonded Fleece", "description": "Two layers fused together for thickness and stability." },
        { "name": "Spunbond Polypropylene", "description": "Nonwoven with papery hand (e.g., tote bags, masks)." },
        { "name": "Tyvek", "description": "Spunbonded HDPE; papery, crinkly, tear-resistant." }
      ]
    },
    {
      "category": "Leather & Skins",
      "types": [
        { "name": "Leather (Full-Grain)", "description": "Natural grain; smooth to pebbled depending on finish." },
        { "name": "Nubuck", "description": "Top-grain leather lightly buffed for velvety nap." }
      ]
    },
    {
      "category": "Surface Finishes & Washes",
      "types": [
        { "name": "Brushed", "description": "Fibers raised for soft, fuzzy hand (e.g., flannel)." },
        { "name": "Peached", "description": "Micro-brushed finish giving peach-skin feel." },
        { "name": "Sandwashed", "description": "Washed for matte, sueded surface (often on silk)." },
        { "name": "Stonewashed", "description": "Abrasive wash creating soft, worn look (e.g., denim)." },
        { "name": "Enzyme Washed", "description": "Biochemical wash for softer hand and reduced pilling." },
        { "name": "Mercerized Cotton", "description": "Treatment for smoother surface and added sheen." }
      ]
    }
  ]
};
